import { useState } from 'react';
import { ConditionalRender } from 'components/layout/ConditionalRender';
import { NewOpportunityMain } from './components/NewOpportunityMain/components/NewOpportunityMain';
import { NewOpportunitySuccess } from './components/NewOpportunitySuccess/NewOpportunitySuccess';

export const NewOpportunity = () => {

    const [createdSuccessfully, setCreatedSuccessfully] = useState<boolean>(false);

    const showSuccess = () => {
        setCreatedSuccessfully(true);
    }

    const hideSuccess = () => {
        setCreatedSuccessfully(false);
    }

    return (
        <>
            <ConditionalRender condition={createdSuccessfully} >
                <NewOpportunitySuccess onCreateAnother={ hideSuccess } />
            </ConditionalRender>
            <ConditionalRender condition={!createdSuccessfully} >
                <NewOpportunityMain onComplete={showSuccess} />
            </ConditionalRender>
        </>
    );
};